import { setIn } from 'immutable';
import {
  MAX_SUPPLY,
  TIMESTAMP_PRESALE, TIMESTAMP_SALE,
  SOLD_OUT,
  PRICE_PRESALE, PRICE_SALE,
  LIMIT_PRESALE, LIMIT_SALE, TIMESTAMP_PRESALE_END, // TIMESTAMP_RAFFLE_END,
} from '../../configs';
import * as AT from './actionTypes';
import { metadata } from '../../metadata';



const now = () => Math.trunc(Date.now() / 1000);


const INITIAL_STATE = {
  traitsCount: metadata.traitsCount,
  traits: metadata.traits,
  tokens: metadata.tokens,

  maxSupply: MAX_SUPPLY,
  totalSupply: 0,
  soldOut: SOLD_OUT,

  pricePresale: PRICE_PRESALE,
  priceSale: PRICE_SALE,
  price: '0',

  limitPresale: LIMIT_PRESALE,
  limitSale: LIMIT_SALE,

  timestamp: now(),
  timestampPresale: TIMESTAMP_PRESALE,
  timestampPresaleEnd: TIMESTAMP_PRESALE_END,
  //timestampRaffleEnd: TIMESTAMP_RAFFLE_END,
  timestampSale: TIMESTAMP_SALE,

  saleOpen: now() >= TIMESTAMP_SALE,
  presaleOpen: now() >= TIMESTAMP_PRESALE && now < TIMESTAMP_PRESALE_END,
  presalePaused: now() >= TIMESTAMP_PRESALE_END && now < TIMESTAMP_SALE,
  //raffleEnded: now() >= TIMESTAMP_RAFFLE_END && now < TIMESTAMP_SALE,
};


function nftReducer(state = INITIAL_STATE, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case AT.CLEAR: {
      return INITIAL_STATE;
    }

    case AT.SET_DATA: {
      return { ...state, ...payload };
    }

    case AT.SET_MATADATA: {
      let temp = setIn(state, ['traitsCount'], payload.traitsCount);
      temp = setIn(temp, ['traits'], payload.traits);
      temp = setIn(temp, ['tokens'], payload.tokens);
      return temp;
    }

    case AT.SET_MAX_SUPPLY: {
      return setIn(state, ['maxSupply'], payload);
    }
    case AT.SET_TOTAL_SUPPLY: {
      let temp = setIn(state, ['totalSupply'], payload);
      if (state.totalSupply >= state.maxSupply)
        temp = setIn(temp, ['soldOut'], true);
      return temp;
    }
    case AT.SET_TIMESTAMP: {
      let temp = setIn(state, ['timestamp'], payload);
      if (temp.timestamp >= temp.timestampSale) {
        temp = setIn(temp, ['saleOpen'], true);
        temp = setIn(temp, ['presaleOpen'], false);
        temp = setIn(temp, ['presalePaused'], false);
        //temp = setIn(temp, ['raffleEnded'], false);
        temp = setIn(temp, ['price'], temp.priceSale);
        /*} else if (temp.timestamp >= temp.timestampRaffleEnd) {
          temp = setIn(temp, ['saleOpen'], false);
          temp = setIn(temp, ['presaleOpen'], false);
          temp = setIn(temp, ['presalePaused'], false);
          //temp = setIn(temp, ['raffleEnded'], true);
          temp = setIn(temp, ['price'], temp.priceSale);*/
      } else if (temp.timestamp >= temp.timestampPresaleEnd) {
        temp = setIn(temp, ['saleOpen'], false);
        temp = setIn(temp, ['presaleOpen'], false);
        temp = setIn(temp, ['presalePaused'], true);
        //temp = setIn(temp, ['raffleEnded'], false);
        temp = setIn(temp, ['price'], temp.pricePresale);
      } else if (temp.timestamp >= temp.timestampPresale) {
        temp = setIn(temp, ['saleOpen'], false);
        temp = setIn(temp, ['presaleOpen'], true);
        temp = setIn(temp, ['presalePaused'], false);
        //temp = setIn(temp, ['raffleEnded'], false);
        temp = setIn(temp, ['price'], temp.pricePresale);
      } else {
        temp = setIn(temp, ['saleOpen'], false);
        temp = setIn(temp, ['presaleOpen'], false);
        temp = setIn(temp, ['presalePaused'], false);
        //temp = setIn(temp, ['raffleEnded'], false);
        temp = setIn(temp, ['price'], temp.pricePresale);
      }
      return temp;
    }
    case AT.SET_TIMESTAMP_PRESALE: {
      return setIn(state, ['timestampPresale'], payload);
    }
    case AT.SET_TIMESTAMP_PRESALE_END: {
      return setIn(state, ['timestampPresaleEnd'], payload);
    }
    /*case AT.SET_TIMESTAMP_RAFFLE_END: {
      return setIn(state, ['timestampRaffleEnd'], payload);
    }*/
    case AT.SET_TIMESTAMP_SALE: {
      return setIn(state, ['timestampSale'], payload);
    }

    case AT.SET_PRICE_PRESALE: {
      return setIn(state, ['pricePresale'], payload);
    }
    case AT.SET_PRICE_SALE: {
      return setIn(state, ['priceSale'], payload);
    }

    default:
      return state;
  }
}

export default nftReducer;
